import React, { forwardRef } from "react";

interface IScrollYProps {
    children?: React.ReactNode;
    height?: number;
    isScrolling?: boolean;
}

export const ScrollY = forwardRef<HTMLDivElement, IScrollYProps>(({ children, height, isScrolling = true }, ref) => {
    return (
        <div ref={ref} className={`${isScrolling && "scroll-y"}`} style={{ height: `${height}px` }}>
            {children}
        </div>
    );
});

ScrollY.displayName = "ScrollY"; // Da izbegnemo warning u React DevTools



// import React, { useRef } from 'react';

// interface IScrollYProps {
//     children?: React.ReactNode;
//     height?: number;
//     isScrolling?: boolean;
// }

// export const ScrollY: React.FC<IScrollYProps> = ({ children, height, isScrolling = true }) => {
//     const viewPortRef = useRef(null);

//     return (
//         <div className={`${isScrolling && 'scroll-y'} `} ref={viewPortRef} style={{ height: `${height}px` }}>
//             {children}
//         </div>
//     );
// };

